/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateLeadDto,
  CreateLeadResponseDto,
  PpraSurveyControllerSaveAnswerBody,
  ProblemDetail,
  SessionSurveyDto,
  SurveyResultsDto
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




export const ppraSurveyControllerGetLatestResults = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SurveyResultsDto>(
      {url: `/session/me/ppra/latest-results`, method: 'GET', signal
    },
      );
    }
  



export const getPpraSurveyControllerGetLatestResultsQueryKey = () => {
    return [
    `/session/me/ppra/latest-results`
    ] as const;
    }

    
export const getPpraSurveyControllerGetLatestResultsQueryOptions = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPpraSurveyControllerGetLatestResultsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>> = ({ signal }) => ppraSurveyControllerGetLatestResults(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PpraSurveyControllerGetLatestResultsQueryResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>>
export type PpraSurveyControllerGetLatestResultsQueryError = ProblemDetail


export function usePpraSurveyControllerGetLatestResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>,
          TError,
          Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePpraSurveyControllerGetLatestResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>,
          TError,
          Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePpraSurveyControllerGetLatestResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePpraSurveyControllerGetLatestResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPpraSurveyControllerGetLatestResultsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const ppraSurveyControllerCreateLead = (
    createLeadDto: CreateLeadDto,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<CreateLeadResponseDto>(
      {url: `/session/me/ppra/lead`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLeadDto, signal
    },
      );
    }
  


export const getPpraSurveyControllerCreateLeadMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext> => {

const mutationKey = ['ppraSurveyControllerCreateLead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, {data: CreateLeadDto}> = (props) => {
          const {data} = props ?? {};

          return  ppraSurveyControllerCreateLead(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerCreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>>
    export type PpraSurveyControllerCreateLeadMutationBody = CreateLeadDto
    export type PpraSurveyControllerCreateLeadMutationError = ProblemDetail

    export const usePpraSurveyControllerCreateLead = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>,
        TError,
        {data: CreateLeadDto},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerCreateLeadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const ppraSurveyControllerSaveAnswer = (
    sessionSurveyId: string,
    surveyItemId: string,
    ppraSurveyControllerSaveAnswerBody: PpraSurveyControllerSaveAnswerBody,
 ) => {
      
      
      return customFetcher<SessionSurveyDto>(
      {url: `/session/me/ppra/${sessionSurveyId}/question/${surveyItemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ppraSurveyControllerSaveAnswerBody
    },
      );
    }
  


export const getPpraSurveyControllerSaveAnswerMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext> => {

const mutationKey = ['ppraSurveyControllerSaveAnswer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, {sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}> = (props) => {
          const {sessionSurveyId,surveyItemId,data} = props ?? {};

          return  ppraSurveyControllerSaveAnswer(sessionSurveyId,surveyItemId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerSaveAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>>
    export type PpraSurveyControllerSaveAnswerMutationBody = PpraSurveyControllerSaveAnswerBody
    export type PpraSurveyControllerSaveAnswerMutationError = ProblemDetail

    export const usePpraSurveyControllerSaveAnswer = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>,
        TError,
        {sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerSaveAnswerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const ppraSurveyControllerGetPpraResults = (
    sessionSurveyId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SurveyResultsDto>(
      {url: `/session/me/ppra/${sessionSurveyId}/results`, method: 'GET', signal
    },
      );
    }
  



export const getPpraSurveyControllerGetPpraResultsQueryKey = (sessionSurveyId?: string,) => {
    return [
    `/session/me/ppra/${sessionSurveyId}/results`
    ] as const;
    }

    
export const getPpraSurveyControllerGetPpraResultsQueryOptions = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPpraSurveyControllerGetPpraResultsQueryKey(sessionSurveyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>> = ({ signal }) => ppraSurveyControllerGetPpraResults(sessionSurveyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionSurveyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PpraSurveyControllerGetPpraResultsQueryResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>>
export type PpraSurveyControllerGetPpraResultsQueryError = ProblemDetail


export function usePpraSurveyControllerGetPpraResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(
 sessionSurveyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>,
          TError,
          Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePpraSurveyControllerGetPpraResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(
 sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>,
          TError,
          Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePpraSurveyControllerGetPpraResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(
 sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePpraSurveyControllerGetPpraResults<TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(
 sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPpraSurveyControllerGetPpraResultsQueryOptions(sessionSurveyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const ppraSurveyControllerCreatePpraSurvey = (
    version: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SessionSurveyDto>(
      {url: `/session/me/ppra/${version}`, method: 'POST', signal
    },
      );
    }
  


export const getPpraSurveyControllerCreatePpraSurveyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext> => {

const mutationKey = ['ppraSurveyControllerCreatePpraSurvey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, {version: string}> = (props) => {
          const {version} = props ?? {};

          return  ppraSurveyControllerCreatePpraSurvey(version,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerCreatePpraSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>>
    
    export type PpraSurveyControllerCreatePpraSurveyMutationError = ProblemDetail

    export const usePpraSurveyControllerCreatePpraSurvey = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>,
        TError,
        {version: string},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerCreatePpraSurveyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    